export const PERIODS = {
    LA_CONG_DOAN: 'Là công đoạn',
    LA_THANH_PHAM: 'Là thành phẩm',
    THUA_DINH: 'Thùa đính',
    NHAT_CHI: 'Nhặt chỉ',
}